//
//
//
//
//
//

export default {
  name: 'CenterScreenObserver',
  props: {
    verticalOnly: Boolean,
    horizontalOnly: Boolean,
  },
  data() {
    return {
      isCenterScreen: false,
      observer: new IntersectionObserver(this.observerCallback, {
        threshold: 0,
        root: document, // need to explicitly specify document for storybook
        rootMargin: `${this.horizontalOnly ? '0%' : '-50%'} ${this.verticalOnly ? '0%' : '-50%'}`,
      }),
    }
  },
  watch: {
    isCenterScreen: {
      immediate: true,
      handler(newValue) {
        this.$emit('isCenterScreenChanged', newValue)
      },
    },
  },
  methods: {
    async observerCallback(entries) {
      if (entries.length) {
        const entry = entries[entries.length - 1]
        const { isIntersecting } = entry
        this.isCenterScreen = isIntersecting
      }
    },
  },
  mounted() {
    this.observer.observe(this.$el)
  },
  beforeDestroy() {
    this.observer.disconnect()
  },
}
